// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"486b6d4a","787":"a89994ef","802":"f35b0d8c","836":"de43244f"}[chunkId] + ".chunk.js";
};